var React = require('react');

function Cyno (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Mobile Cyno Inhibiter"),React.createElement("g",{"id":"g1653","key":2},[React.createElement("circle",{"id":"path3426","className":"cls-1","cx":"64","cy":"64","r":"30","key":0}),React.createElement("path",{"id":"path3445","className":"cls-1","d":"M24,104l80-80","key":1}),React.createElement("path",{"id":"path3447","className":"cls-1","d":"M104,104,24,24","key":2})])]);
}

Cyno.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Cyno;

Cyno.default = Cyno;
